import React from 'react';
/**
 * ImpressionContext will be used to provide the generated impression_id to
 * other components if they need it for things like interaction tracking.
 */

var ImpressionContext = /*#__PURE__*/React.createContext(null);
export default ImpressionContext;